import React from 'react'

export default () => (
  <div className="stats-pane">
    <div className="stat">
      <div className="stat-number">
        10B+
      </div>
      <div className="stat-text">
        Streamable video views
      </div>
    </div>
    <div className="stat">
      <div className="stat-number">
        20K+
      </div>
      <div className="stat-text">
        Videos uploaded per day
      </div>
    </div>
    <div className="stat">
      <div className="stat-number">
        10K+
      </div>
      <div className="stat-text">
        Sites using Streamable
      </div>
    </div>
    <div className="stat">
      <div className="stat-number">
        50M+
      </div>
      <div className="stat-text">
        Monthly active users
      </div>
    </div>
  </div>
)
